'use client'

import { useHydrateAtoms } from 'jotai/utils'

import { qrUriAtom } from '../../../generatorState'
import { TVCardContent, vCardContentAtom } from './vCardContentState'
import { VCardScreen } from './VCardScreen/VCardScreen'
import { vCardIsUnlockedAtom } from './VCardScreen/VCardScreenState'

export const VCardLandingScreen = ({
	uri,
	content,
	isUnlocked,
}: {
	uri: string
	content: TVCardContent
	isUnlocked?: boolean
}) => {
	useHydrateAtoms([
		[qrUriAtom, uri],
		[vCardContentAtom, content],
		[vCardIsUnlockedAtom, isUnlocked ?? false],
	])

	return <VCardScreen previewMode={false} demoMode={false} />
}
